import scrollTo from '../utils/scroll-to';

document.addEventListener('layoutOpen', (event) => {
	if (event.target.matches('.slx-flap')) {
		scrollTo(event.target);
	}
});
